<template>
  <div id="Debtor" dir="rtl">
    <loading v-if="loadingRender"></loading>
    <panel Title="فرم برداشت وجه" Des="از طریق این فرم می توانید درخواست برداشت وجه خودرا اعلام کنید" :IsBtnBack="true" :IsBtnClose="false" ClassCustom="bg-dark-Custom text-right"></panel>
    <div class="row">
      <div class="col-lg-12 col-12">
        <net-pa-card>
          <template v-slot:header>
            <h4>برداشت از حساب</h4>
          </template>
          <template slot="content">
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-lg-4 col-12">
                    <div v-if="!TaahodatId && !GhebelBardasht">
                      <small>انتخاب حساب</small>
                      <select v-if="IsLoad" name="cmbTaahodat" id="cmbTaahodat" class="form-control Pointer" v-model="Resultcmb">
                        <option v-if="this.IsLoad == false" value="-2">|| در حال بارگذاری ، منتظر بمانید ... ||</option>
                        <option selected value="-1">-- انتخاب حساب --</option>
                        <option v-for="item in this.ListModel" :key="item.id" :value="item">
                          <span>{{ item.vcodeDesNo }} </span>
                          <span>{{ item.nameFamily }} </span>
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-2 col-12 pt-2 pr-2">
                    <span class="mt-4 d-block">مبلغ قابل برداشت: {{ Resultcmb ? $Comma3ragham(Resultcmb.ghabelBardasht + Resultcmb.sumMabTaeedNaShode) : '' }}</span>
                  </div>

                  <div class="col-lg-4 col-12 pt-6 pr-2 mt-4 mt-lg-0">
                    <span>مبـــلغ برداشت</span>
                    <input type="text" ref="txtMablagh" id="txtMablagh" tabindex="1" class="form-control 3ragham text-center" style="font-size: 15px !important" v-model="MabBardasht" />
                  </div>

                  <div class="col-lg-2 col-12 pt-6 pr-2">
                    <span class="d-block text-dark font-weight-bold mt-4" style="font-size: 14px !important">{{ Mab2persian }}</span>
                  </div>
                </div>

                <article v-if="$session.get('CustCode') != 801">
                  <div class="row mt-4">
                    <div class="col-lg-6 mt-3 col-12 form-control">
                      <small class="d-lg-inline d-none">انتخاب روش انتقال:</small>
                      <div class="radio pr-4">
                        <input v-if="$session.get('CustCode') != 561 && $session.get('CustCode') != 866" label="انتقال به کارت" type="radio" name="NoeEnteghal" value="Card" checked="NoeEnteghal == 'Card'" v-model="NoeEnteghal" @click="ShowList = false" />
                        <input label="انتقال به شبا" type="radio" name="NoeEnteghal" value="Sheba" checked="NoeEnteghal == 'Sheba'" v-model="NoeEnteghal" @click="ShowList = false" />
                      </div>
                    </div>
                    <!-- <div class="col-lg-2 col-12">
                      <small>نام بانک</small>
                      <SelectCombo @result="getSelectedBank" :readFromAction="'SelAzaHesab/GetBanks'"></SelectCombo>
                    </div> -->

                    <div class="col-lg-4 col-12 mt-3 mt-lg-0" v-if="NoeEnteghal == 'Card'">
                      <small>شماره کارت: </small>

                      <div class="row" dir="ltr">
                        <div class="col-lg-12 col-12">
                          <div class="row">
                            <div class="col-3 px-md-3 p-0">
                              <input type="number" class="form-control text-center" id="FirstInput" @input="First4Digit.length >= 4 ? ((First4Digit = First4Digit.slice(0, 4)), jumpTo('SecondInput')) : void 0" v-model="First4Digit" />
                            </div>
                            <div class="col-3 px-md-3 p-0">
                              <input type="number" class="form-control text-center" id="SecondInput" @input="Second4Digit.length >= 4 ? ((Second4Digit = Second4Digit.slice(0, 4)), jumpTo('ThirdInput')) : void 0" v-model="Second4Digit" />
                            </div>
                            <div class="col-3 px-md-3 p-0">
                              <input type="number" class="form-control text-center" id="ThirdInput" @input="Third4Digit.length >= 4 ? ((Third4Digit = Third4Digit.slice(0, 4)), jumpTo('lastInput')) : void 0" v-model="Third4Digit" />
                            </div>
                            <div class="col-3 px-md-3 p-0">
                              <input type="number" class="form-control text-center" id="lastInput" @input="Forth4Digit.length >= 4 ? ((Forth4Digit = Forth4Digit.slice(0, 4)), jumpTo('NameSahebHesab')) : void 0" v-model="Forth4Digit" />
                            </div>
                          </div>
                        </div>
                        <!-- <div class="col-lg-1 col-2 text-center">
                          <i
                            class="fa fa-list text-warning mt-2 fa-2x Pointer"
                            title="لیست کارت های ذخیره شده"
                            @click="
                              KEY++
                              GetDataShebaOrCard()
                              ShowList = !ShowList
                            "
                          ></i>
                        </div> -->
                      </div>
                    </div>
                    <div class="col-lg-4 col-12 mt-lg-0 mt-3" v-if="NoeEnteghal == 'Sheba'">
                      <small>شماره شبا: </small>
                      <div class="row" dir="ltr">
                        <div class="col-lg-1 col-2">
                          <small class="d-lg-inline d-none" style="font-size: 1.7rem; white-space: nowrap">IR</small>
                        </div>
                        <div class="col-lg-11 col-12">
                          <input type="number" @input="ShebaNo.length > 24 ? ((ShebaNo = ShebaNo.slice(0, 24)), jumpTo('NameSahebHesab')) : void 0" class="form-control" v-model="ShebaNo" />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2 col-12">
                      <div class="row">
                        <div class="col-2 pt-4" v-if="NoeEnteghal == 'Sheba'">
                          <i class="fa fa-search text-primary mt-2 fa-2x Pointer" title="استعلام شماره شبا" @click="Estelam"></i>
                        </div>
                        <div class="col-2 pt-4">
                          <i
                            class="fa fa-list text-warning mt-2 fa-2x Pointer"
                            title="لیست شبا های ذخیره شده"
                            @click="
                              KEY++
                              GetDataShebaOrCard()
                              ShowList = !ShowList
                            "
                          ></i>
                        </div>
                      </div>
                    </div>

                    <div class="mt-4 col-md-6 col-12">
                      <div class="row">
                        <div class="col-lg-6 col-12">
                          <small>نام صاحب حساب</small>
                          <input id="NameSahebHesab" type="text" v-model="NameSahebHesab" class="form-control" />
                        </div>
                        <div class="col-lg-6 col-12">
                          <div class="custom-control custom-switch mt-3">
                            <input type="checkbox" class="custom-control-input InputText" v-model="SaveShebaOrCard" id="SaveShebaOrCard" />
                            <label class="custom-control-label mt-2 Pointer" for="SaveShebaOrCard"></label>
                            <label class="mt-3 mr-5 Pointer" v-if="NoeEnteghal == 'Card'"> ذخیره اطلاعات کــــارت </label>
                            <label class="mt-3 mr-5 Pointer" v-else> ذخیره اطلاعات شـــبا </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="mt-2 col-lg-6 col-12">
                      <div v-if="ShowList" class="row BoxList" :key="KEY">
                        <div class="col-12 alert bg-dark text-light text-center">لیست <span v-if="NoeEnteghal == 'Card'"> کارت های </span><span v-else> شبا های </span> ذخیره شده</div>
                        <div class="col-12">
                          <div class="border-Sheba row mt-1 py-3 w-100" v-for="(item, key) in NoeEnteghal == 'Card' ? ListCard : ListSheba" :key="key">
                            <div class="col-lg-8 text-left">
                              <div class="">
                                <span class="text-warning" v-if="NoeEnteghal != 'Card'"> IR </span>
                                <span>{{ item.shebaOrCardNum }}</span>
                              </div>
                              <div class="text-left">
                                <span class="text-warning">نام صاحب حساب : </span>
                                <span>{{ item.sahebShebaOrCard }}</span>
                              </div>
                            </div>
                            <div class="col-lg-4 text-center">
                              <!-- <span v-if="item.selected != true" class="badge badge-secondary px-2 font-weight-normal Pointer mt-2" style="font-size: 14px !important" @click="SelectShebaOrCard(item.id, NoeEnteghal != 'Card' ? true : false)">انتخاب</span>
                          <span v-else class="badge badge-success px-2 font-weight-normal Pointer mt-2" style="font-size: 14px !important">انتخاب شد</span> -->
                              <span v-if="item.selected != true" class="Pointer mt-2 mr-3" style="font-size: 14px !important" @click="SelectShebaOrCard(item.id, NoeEnteghal != 'Card' ? true : false)" title="انتخاب شماره"><i class="fa fa-check hover-info"></i></span>
                              <span v-else class="Pointer mt-2 mr-3" style="font-size: 14px !important"><i class="fa fa-check text-success"></i></span>
                              <!-- <span class=" Pointer mt-2 mr-3" style="font-size: 14px !important"><i class="fa fa-pen hover-warning"></i></span> -->
                              <span class="Pointer mt-2 mr-3" style="font-size: 14px !important" @click="RemoveShebeOrCard(item)" title="حذف شماره"><i class="fa fa-trash hover-danger"></i></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="ShowEstelam" class="row p-2" :key="KEY">
                        <div class="w-100 border rounded p-2">
                          <div class="row">
                            <div class="col-12"><small>شماره حساب:</small> {{ EstelamData.accountNumber }}</div>
                            <div class="col-12"><small> مشخصات حساب:</small> {{ EstelamData.accountComment }}</div>
                            <div class="col-12">
                              <small>صاحبان حساب :</small>
                              <span v-for="(item, index) in EstelamData.holders" :key="index">
                                <span v-if="item.firstName != ''">{{ item.firstName + ' ' + item.lastName + ',' }} </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
                <div class="mt-5 text-center">
                  <button v-if="!twoLevel" class="btn btn-danger w-75" style="font-size: 14px !important" @click="SabtBardasht(TaahodatId)">
                    {{ GetMablagh }}
                  </button>
                  <button id="CloseModal" class="btn btn-danger w-75 d-none" style="font-size: 14px !important" data-dismiss="modal"></button>
                </div>
              </div>
              <div v-if="twoLevel == true" class="col-12">
                <div class="row mt-4">
                  <hr class="mt-2" />
                  <div class="col-md-2 col-12"></div>
                  <div class="col-md-6 col-12">
                    <small>لطفا رمز پیامک شده را برای انجام تراکنش را وارد کنید</small>
                    <input v-model="twstepCode" type="number" class="form-control text-center" />
                  </div>
                  <div class="col-md-2 col-12">
                    <button @click="CheckCode" class="btn btn-success mt-4 w-100">تایید</button>
                  </div>
                  <div class="col-md-2 col-12"></div>
                </div>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
    </div>
  </div>
</template>
<script>
import Num2persian from 'num2persian'
import Panel from '../Tools/NetPa/Panel.vue'
import loading from '../Tools/NetPa/Loading.vue'
import ModalCustom from '../Tools/ModalCustom.vue'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import SelectCombo from '@/components/Tools/SelectCombo.vue'

export default {
  data() {
    return {
      twstepCode: '',
      twoLevel: false,
      EstelamData: {
        accountNumber: '',
        holders: [{ firstName: '', lastName: '' }],
      },
      tblBankId: null,
      ShowList: false,
      ShowEstelam: false,
      KEY: 0,
      First4Digit: '',
      Second4Digit: '',
      Third4Digit: '',
      Forth4Digit: '',
      MabBardasht: '',
      NameSahebHesab: '',
      BankName: '',
      ShebaNo: null,
      CardNo: null,
      NoeEnteghal: 'Sheba',
      DataAxios: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'EnteghalVajh',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_cmbTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/TaahodatSahebHesab',
        Token: this.$session.get('TokenNetPa'),
      },
      IsLoad: false,
      Resultcmb: null,
      rows: [],
      columns: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'ردیف',
          name: 'row',
        },

        {
          label: 'عنوان حساب',
          name: 'DesNoe',
        },
        {
          label: 'کد حساب',
          name: 'VCode',
        },
        {
          label: 'مبلغ برداشت',
          name: 'Bestan',
        },
        {
          label: 'زمان تراکنش',
          name: 'ZamanInsert',
        },
        {
          label: 'تاریخ سند',
          name: 'TarixSanad',
        },
        {
          label: 'کد رهگیری',
          name: 'CodeRahgiri',
        },
        {
          label: 'شرح برداشت',
          name: 'SharhSanad',
        },
      ],
      config: {
        pagination: true,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: '',
        card_mode: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: 'table-bordered table-striped table-sm ',
      },
      loadingRender: false,
      ListModel: null,
      ListModelSahebHesab: null,
      SaveShebaOrCard: false,
      ListSheba: [],
      ListCard: [],
    }
  },
  components: {
    Panel,
    loading,
    ModalCustom,
    NetPaCard,
    SelectCombo,
  },
  props: ['TaahodatId', 'GhebelBardasht'],
  updated() {
    this.$PutCommatoInput()
  },
  computed: {
    Mab2persian() {
      var Mab = this.MabBardasht.replace(/,/g, '')
      Mab = this.$b_ToPersianNumber(Mab)
      return ' مبلـغ ' + Num2persian(Mab) + ' ' + this.$cookies.get('VahedPool')
    },
    GetMablagh() {
      var Mab = this.MabBardasht.replace(/,/g, '')
      Mab = this.$b_ToPersianNumber(Mab)
      return ' برداشــت ' + this.$Comma3ragham(Mab) + ' ' + this.$cookies.get('VahedPool')
    },
  },
  methods: {
    SabtBardasht(id) {
      if (this.$session.get('CustCode') != 801) {
        if (this.MabBardasht.replace(/,/g, '').length < 4) {
          this.$mySweetDefault('خطا', 'مبلغ برداشت نمی تواند کمتر از 10,000 ' + this.$cookies.get('VahedPool') + ' یا خالی باشد', 'error', 2500)
          return
        }
        if (this.NoeEnteghal == 'Card') {
          this.ShebaNo = ''
          this.CardNo = this.First4Digit + this.Second4Digit + this.Third4Digit + this.Forth4Digit
          if (this.CardNo.length != 16) {
            this.$mySweetDefault('خطا', 'شماره کارت صحیح نمیباشد', 'error', 2500)
            return
          }
        } else {
          this.CardNo = ''
          if (this.ShebaNo == null || this.ShebaNo.length != 24) {
            this.$mySweetDefault('خطا', 'شماره شبا صحیح نمیباشد', 'error', 2500)
            return
          }
        }
        if (this.NameSahebHesab.length < 1) {
          this.$mySweetDefault('خطا', 'نام صاحب حساب وارد نشده است', 'error', 2500)
          return
        }
      }
      if (Number(this.MabBardasht.replace(/,/g, '')) <= this.Resultcmb.ghabelBardasht + this.Resultcmb.sumMabTaeedNaShode) {
        var NameSahebHesab = this.$session.get('CustCode') != 801 ? this.NameSahebHesab : this.$session.get('UserInfoNetPa').ozvName + ' ' + this.$session.get('UserInfoNetPa').ozvFamily

        this.$SweetQustion(
          'اطمینان از برداشت وجه',
          ' از برداشت وجه به مبلغ ' + this.$Comma3ragham(Number(this.MabBardasht.replace(/,/g, ''))) + this.$cookies.get('VahedPool') + '  به شماره شـــبا یا شماره کــــارت ' + this.CardNo + this.ShebaNo + '  به نام آقا | خانم ' + NameSahebHesab + ' اطمینان دارید ؟ ',
          'question',
          'تایید برداشت',
          'انصراف',
          id,
          this.checkSms,
          this.isNotConfirmed
        )
      } else {
        this.$mySweetDefaultTost('خطا', 'مبلغ برداشت نمیتواند بیشتر از مبلغ قابل برداشت باشد حساب باشید', 'warning', 2000)
        return
      }
    },
    jumpTo(id) {
      document.getElementById(id).focus()
    },
    checkSms() {
      if (this.$session.get('CustCode') == '255') {
        this.sendTwoStepCode()
      } else this.ConfirmBardasht()
    },
    sendTwoStepCode() {
      this.twoLevel = true
      var DataAxiosSms = { Method: 'GET', Token: this.$session.get('TokenNetPa'), Action: 'twoStepVerification?wwwtblAzaId=' + this.$session.get('UserInfoNetPa').wwwtblAzaId, ArryfildValue: null }
      this.$PostData(DataAxiosSms).then((result) => {
        if (result.status == 'success') {
          this.$mySweetDefaultTost('', result.msg, 'success', 2800)
        }
      })
    },
    CheckCode() {
      var DataAxiosCheckCode = { Method: 'POST', Token: this.$session.get('TokenNetPa'), Action: 'twoStepVerification', ArryfildValue: { wwwtblAzaId: this.$session.get('UserInfoNetPa').wwwtblAzaId, Code: this.twstepCode + '' } }
      this.$PostData(DataAxiosCheckCode).then((result) => {
        if (result.status) {
          this.ConfirmBardasht()
        } else {
          this.$mySweetDefaultTost('خطا', 'رمز دو مرحله ای وارد شده صحیح نمیباشد. دوباره تلاش کنید', 'error', 2800)
        }
      })
    },
    ConfirmBardasht(id) {
      if (this.SaveShebaOrCard == true) {
        this.SaveDataShebaOrCard().then((data) => {
          if (data == true) {
            this.$mySweetDefaultTost('عملیات موفق', 'ذخیره اطلاعات شبا و یا کارت با موفقیت انجام گردید', 'success', 2000)
          } else {
            this.$mySweetDefaultTost('عملیات ناموفق', 'ذخیره اطلاعات شبا و یا کارت با خطا روبه رو شد', 'danger', 2000)
          }
        })
      }
      this.loadingRender = true
      var Mablagh = this.MabBardasht.replace(/,/g, '')
      var NameSahebHesab = this.$session.get('UserInfoNetPa').ozvName + ' ' + this.$session.get('UserInfoNetPa').ozvFamily
      if (this.ShebaNo != null && this.ShebaNo != '') {
        var ShebaIR = 'IR' + this.ShebaNo
      }
      const formData = new FormData()
      formData.append('wwwtblTaahodatIdBestanKar', 0)
      formData.append('wwwtblTaahodatIdBedehKar', id ? id : this.Resultcmb.id)
      formData.append('Mablagh', Mablagh)
      formData.append('Desc', 'درخواست برداشت از حساب')
      formData.append('KodRahgiri', '')
      formData.append('CardNo', this.$session.get('CustCode') != 801 ? this.CardNo : '')
      formData.append('ShebaNo', this.$session.get('CustCode') != 801 ? ShebaIR : '')
      formData.append('NameSahebHesab', this.$session.get('CustCode') != 801 ? this.NameSahebHesab : NameSahebHesab)
      formData.append('EnteghalNoe', 6)
      formData.append('HesabNo', '')
      formData.append('OrderId', '-2')
      formData.append('MabKarmozdEnteghal', 0)
      formData.append('MabKarmozdBnp', 0)
      formData.append('BankName', this.$session.get('CustCode') != 801 ? this.BankName : '')
      formData.append('ComboIdGrp324', '')
      formData.append('TarixSanad', this.$store.state.JalaliDate)
      // formData.append('tblBankId', this.tblBankId)
      this.DataAxios.ArryfildValue = formData
      this.$PostFormData(this.DataAxios).then((data) => {
        if (data.success === 'SUCCESS') {
          document.getElementById('CloseModal').click()
          this.$mySweetDefault('درخواست موفقیت آمیز', 'درخواست برداشت با موفقیت انجام شد ، کد رهگیری شما :' + data.codeRahgiri, 'success', 7000)
          this.loadingRender = false
          this.$router.push({ name: 'DebtorReport' })
          // checkIn
        } else {
          this.loadingRender = false
          this.$mySweetDefaultTost('خطا', 'در برداشت از حساب مشکلی پیش آمده لطفا مجددا تلاش کنید', 'warning', 2000)
        }
      })
    },
    SaveDataShebaOrCard() {
      return new Promise((success, reject) => {
        let Data = {
          Id: 0,
          wwwtblAzaId: this.$session.get('UserInfoNetPa').wwwtblAzaId,
          IsSheba: this.NoeEnteghal == 'Card' ? false : true,
          SahebShebaOrCard: this.NameSahebHesab,
          ShebaOrCardNum: this.CardNo.length > 0 ? this.CardNo : this.ShebaNo,
          IsBardasht: true,
        }
        var DataAxiosFindShebaOrCard = { ArryfildValue: Data, Method: 'Post', Action: 'ShebaOrCard', Token: this.$session.get('TokenNetPa') }
        this.$PostData(DataAxiosFindShebaOrCard).then((data) => {
          if (data.status == 'Success') {
            success(true)
          }
          // else if(data.status == 'Dup') {
          //   //اطلاعات شبا و یا کارت تکراری بوده
          // }
          else {
            //خطا در ذخیره
          }
        })
      })
    },
    GetDataShebaOrCard() {
      var DataAxios = {
        ArryfildValue: '',
        Method: 'post',
        Action: 'ShebaOrCard/GetShebaOrCard',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((data) => {
        data.forEach((value) => {
          value['select'] = false
        })
        this.ListCard = data.filter((x) => x.isSheba == false && x.isBardasht == true)
        this.ListSheba = data.filter((x) => x.isSheba == true && x.isBardasht == true)
      })
    },
    SelectShebaOrCard(id, isSheba) {
      if (isSheba) {
        this.ListSheba.forEach((el) => {
          if (el.id == id) {
            el.selected = true
            this.ShebaNo = el.shebaOrCardNum
            this.NameSahebHesab = el.sahebShebaOrCard
            this.KEY++
          } else {
            el.selected = false
          }
        })
      } else {
        this.ListCard.forEach((el) => {
          if (el.id == id) {
            el.selected = true
            this.First4Digit = el.shebaOrCardNum.slice(0, 4)
            this.Second4Digit = el.shebaOrCardNum.slice(4, 8)
            this.Third4Digit = el.shebaOrCardNum.slice(8, 12)
            this.Forth4Digit = el.shebaOrCardNum.slice(12, 16)
            this.NameSahebHesab = el.sahebShebaOrCard
            this.KEY++
          } else {
            el.selected = false
          }
        })
      }
      this.ShowList = false
    },
    RemoveShebeOrCard(row) {
      this.$SweetQustion('اطمینان ازحذف', ' از حذف شماره شبا و یا شماره کارت ' + row.shebaOrCardNum + ' به نام  ' + row.sahebShebaOrCard + ' اطمینان دارید ؟ ', 'question', 'تایید حذف', 'انصراف', row.id, this.ConfirmRemoveShebaOrCard, this.isNotConfirmed)
    },
    ConfirmRemoveShebaOrCard(id) {
      var DataAxios = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ShebaOrCard/DeleteShebaOrCard',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      formData.append('wwwtbShebaOrCardId', id)
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((data) => {
        if (data.status == 'Success') {
          this.GetDataShebaOrCard()
          this.KEY++
          this.$mySweetDefaultTost('حذف موفق', ' حذف شماره شبا یا شماره کارت انتخابی شما با موفقیت انجام شد', 'success', 2000)
        }
      })
    },
    isNotConfirmed() {},
    Estelam() {
      this.loadingRender = true

      var data = {
        CustCode: this.$session.get('CustCode'),
        Sign: '',
        IbanNumber: 'IR' + this.ShebaNo,
      }
      var EstelamAxios = { action: 'EstelamSheba/Index', method: 'POST', arryfildValue: data }

      this.$PostData_netpatoken(EstelamAxios)
        .then((result) => {
          if (typeof result == 'string' || result.isSuccess == false) {
            var message = result == 'string' ? result : result.message
            this.$mySweetDefault('خطا', message, 'error', 2000)
          } else {
            this.EstelamData.accountNumber = result.accountNumber
            this.EstelamData.holders = result.ibanAccountOwnerList
            this.EstelamData.accountComment = result.accountComment
            this.ShowEstelam = true
            this.ShowList = false
            this.NameSahebHesab = ''
            this.SaveShebaOrCard = ''
            this.EstelamData.holders.forEach((person) => {
              this.NameSahebHesab = this.NameSahebHesab + person.firstName + ' ' + person.lastName + '،'
              this.SaveShebaOrCard = this.SaveShebaOrCard + person.firstName + ' ' + person.lastName + '،'
            })
          }
        })
        .finally(() => {
          this.loadingRender = false
        })
    },
    getSelectedBank(data) {
      this.tblBankId = data.bnpcashDbId
    },
  },
  mounted() {
    // this.$refs.txtMablagh.focus()
    const formData = new FormData()
    let info
    formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
    formData.append('wwwtblSarfaslTypeId', 2)
    this.DataAxios_cmbTaahodat.ArryfildValue = formData
    this.$PostFormData(this.DataAxios_cmbTaahodat)
      .then((data) => {
        this.IsLoad = true
        this.ListModel = data.filter((x) => x.tblSarfaslTypeId != 6)
        this.Resultcmb = data[0]
      })
      .finally(() => {
        const formData = new FormData()
        formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
        formData.append('wwwtblSarfaslTypeId', 2)
        this.DataAxios_SahebHesab.ArryfildValue = formData
        this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
          if (data.length > 0) {
            this.IsLoad = true
            this.ListModelSahebHesab = data
            for (let index = 0; index < this.ListModelSahebHesab.length; index++) {
              if (this.ListModelSahebHesab[index].mande > 0) {
                info = this.ListModelSahebHesab[index]
                this.ListModel.push(info)
              }
            }
          }
          if (this.TaahodatId) {
            this.ListModel.forEach((e) => {
              if (e.id == this.TaahodatId) {
                this.Resultcmb = e
              }
            })
          }
        })
      })
  },
  created() {},
}
</script>
<style scoped>
.BoxList {
  max-height: 30vh !important;
  overflow-y: scroll;
}
.border-Sheba {
  border: 2px dashed #435ebe !important;
  border-radius: 8px;
}
.card {
  border-radius: 15px !important;
}

.radio {
  padding: 4px;
  text-align: center;
  position: relative;
  display: inline;
}

.radio input {
  width: auto;
  height: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  cursor: pointer;
  border-radius: 2px;
  padding: 4px 8px;
  color: #bdbdbdbd;
  font-size: 14px;
  transition: all 100ms linear;
}

.radio input {
  color: #000 !important;
  background-image: linear-gradient(180deg, #bdc3db, #a3a4aa);
}
.radio input:checked {
  background-image: linear-gradient(180deg, #435ebe, #5770c9);
  color: #fff !important;
  box-shadow: 0 1px 1px #0000002e;
  text-shadow: 0 1px 0px #79485f7a;
}

.radio input:before {
  content: attr(label);
  display: inline-block;
  text-align: center;
  width: 100%;
}
.btn-ListCard {
  background-image: linear-gradient(180deg, #435ebe, #5770c9);

  color: #fff !important;
  box-shadow: 0 1px 1px #0000002e;
  text-shadow: 0 1px 0px #79485f7a;
}
</style>
